import { render, staticRenderFns } from "./comments-list-reply.vue?vue&type=template&id=2227733d"
import script from "./comments-list-reply.vue?vue&type=script&lang=ts"
export * from "./comments-list-reply.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports